import React, { useState, useMemo } from 'react';
import Modal from './Modal';
import type { FileSystem } from '../types';
import { getAllFolders } from '../utils/fileSystemUtils';

interface MovePromptModalProps {
  fileSystem: FileSystem;
  promptId: string;
  currentFolderId: string | null;
  onMove: (promptId: string, targetFolderId: string) => void;
  onClose: () => void;
}

const MovePromptModal: React.FC<MovePromptModalProps> = ({ fileSystem, promptId, currentFolderId, onMove, onClose }) => {
  const folders = useMemo(() => getAllFolders(fileSystem).filter(f => f.id !== 'trash'), [fileSystem]);
  const [targetFolderId, setTargetFolderId] = useState<string>(
    (currentFolderId && currentFolderId !== 'trash') ? currentFolderId : (folders[0]?.id ?? '')
  );

  return (
    <Modal title="Prompt verschieben" onClose={onClose}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onMove(promptId, targetFolderId);
        }}
      >
        <label htmlFor="targetFolder" className="text-sm text-gray-600 dark:text-gray-300">Zielordner</label>
        <select
          id="targetFolder"
          value={targetFolderId}
          onChange={(e) => setTargetFolderId(e.target.value)}
          className="mt-1 w-full px-3 py-2 rounded-md bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          {folders.map(folder => (
            <option key={folder.id} value={folder.id}>{folder.name}</option>
          ))}
        </select>
        <div className="flex justify-end gap-3 mt-4">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-md text-sm font-medium bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500">Abbrechen</button>
          <button type="submit" className="px-4 py-2 rounded-md text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700">Verschieben</button>
        </div>
      </form>
    </Modal>
  );
};

export default MovePromptModal;
